// extracted by mini-css-extract-plugin
export default {"column":"_32bfde56","title":"_db901580","list":"_51a9f762","navigationRefreshTitle":"_c2db1137"};